import React from 'react';
import './App.css'; // Import the CSS file

function Footer() {
  return (
    <footer className="footer">
      <hr style={{opacity:"20%",marginBottom:"30px",color:"gray"}}/>
      <p style={{marginBottom:"10px"}}>&copy; 2024 ADITYA VERMA</p>
    </footer>
  );
}

export default Footer;
